import React from "react";
import { Card } from "../../../../CommonElements/Hajj/Card";
import { useTranslation } from "react-i18next";
import { STACK_4 } from "./PilgrimDetails";
import { LabelValue } from "@Component/Value";

export const CampData = (props) => {
  const { t } = useTranslation();
  const { isLoading } = props;

  const { camp_code, zone, gate, mina_street, arafat_street } = props;

  const VerticalLabelValue = (props) => (
    <LabelValue loading={isLoading} {...props} />
  );

  return (
    <Card header={<span className="H5">{t("CAMP_DATA")}</span>}>
      <STACK_4>
        <VerticalLabelValue
          copyValue={camp_code}
          label={t("CAMP_CODE")}
          value={camp_code || "-"}
        />
        <VerticalLabelValue label={t("ZONE")} value={zone || "-"} />
        <VerticalLabelValue label={t("GATE")} value={gate || "-"} />
        <VerticalLabelValue
          label={t("MINA_STREET")}
          value={mina_street || "-"}
        />
        <VerticalLabelValue
          label={t("ARAFAT_STREET")}
          value={arafat_street || "-"}
        />
      </STACK_4>
    </Card>
  );
};
